import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Calendar} from "primereact/calendar";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import Message from "../Helpers/Message.js";
import {fetch_url_post,format_date,focus_next} from "../../Sources/js/app.js";

let oper="";

let currentDate=new Date();
let currentYear=currentDate.getFullYear();
let yearsList=[];

for(let i=-2;i<2;i++) {
	let cYear={
		label: currentYear+i,
		value: currentYear+i
	}
	yearsList.push(cYear);
} 

let defaultInputValues={
	id: null,
	no: "",
	aquisition_date: currentDate,
	center_id: 0,
	observations: "",
	filter_centers: "",
	filter_products: "",
	filter_years: currentYear,
	provider_id: 0,
	filter_providers: "",
};

let defaultInputValuesProducts={
	id: null,
	aquisition_id: 0,
	product_id: 0,
	product_mu_id: "",
	quantity: "",
	filter_products: "",
	product_type_id: 0,
	filter_product_type: "",
	observations: "",
};

let defaultDataValues={
	aquisitionsList: [],
	productsList: [],
	centersList: [],
	providersList: [],
	aquisitionProductsList: [],
	MUsList:[],
	productsTypesList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openListProducts: false,
	titleListProducts: "",
	openAddEditProduct: false,
	titleAddEditProduct: "",
	openClone: false,
	titleClone: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let currentAquisition={};

const Aquisitions = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.centerId?props.centerId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [aquisitionsList, setAquisitionsList] = useState([]);
	const [productsList, setProductsList] = useState([]);
	const [inputValuesProducts, setInputValuesProducts] = useState(defaultInputValuesProducts);
	const [aquisitionProductsList, setAquisitionProductsList] = useState([]);
	const [tableQuantities, setTableQuantities] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="filter_centers") {
			setAquisitionsList(dataValues.aquisitionsList.filter((aquisition)=>((aquisition.center_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		if(name==="filter_products") {
			setProductsList(dataValues.productsList.filter((product)=>((product.description.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		if(name==="filter_years") {
			setAquisitionsList(dataValues.aquisitionsList.filter((aquisition)=>((aquisition.year===value))||(value==="")));
		}
		if(name==="filter_providers") {
			setAquisitionsList(dataValues.aquisitionsList.filter((aquisition)=>((aquisition.provider_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChangeProducts = evt => {
		const {name, value} = evt.target;
		let state_update=0;
		if(name==="product_id") {
			let tmp=dataValues.productsList.filter((product)=>(product.id===value));
			setInputValuesProducts({...inputValuesProducts,product_mu_id:tmp[0].product_mu_id,
															product_id:value
			});
			state_update=1;
			let found=false;
			if(dataValues.aquisitionProductsList.length>0) {
				dataValues.aquisitionProductsList.forEach(element => {
					if((value===element.product_id)&&(tmp[0].product_mu_id===element.product_mu_id)) {
						found=true;
					}
				});
			}
			tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
		}
		if(name==="product_mu_id") {
			let found=false;
			if(dataValues.aquisitionProductsList.length>0) {
				dataValues.aquisitionProductsList.forEach(element => {
					if((value===element.product_mu_id)&&(inputValuesProducts.product_id===element.product_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_products") {
			setAquisitionProductsList(dataValues.aquisitionProductsList.filter((product)=>((product.product_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		if(name==="product_type_id") {
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
		}
		if(name==="filter_product_type") {
			setAquisitionProductsList(dataValues.aquisitionProductsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
		}
		if((name==="unitary_price")||(name==="min_quantity")||(name==="max_quantity")) {
			if(!evt.target.validity.valid) {
				setMessageText("Eroare: Sunt permise numai cifre!");							
				return false;
			}
		}
		if(!state_update) {
			setInputValuesProducts({...inputValuesProducts,[name]:value});
		}
	}

	const handleChangeTable = (evt,id) => {
		const {name, value} = evt.target;
		if(name==="quantity_table") {
			if(!evt.target.validity.valid) {
				setMessageText("Eroare: Sunt permise numai cifre!");							
				return false;
			}
			let tmp={...tableQuantities};
			tmp[id]=value;
			setTableQuantities(tmp);
		}
	}

	const handleFocusTable = (evt) => {
		if(evt.keyCode===13) {
			focus_next(evt);
		}
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare achizitie noua"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			let tmp={...elementData};
			tmp.filter_centers=inputValues.filter_centers;
			tmp.filter_providers=inputValues.filter_providers;
			tmp.filter_years=inputValues.filter_years;
			let tmp_data=elementData.aquisition_date_parsed.split("-");
			tmp.aquisition_date=new Date(tmp_data[2]+"-"+tmp_data[1]+"-"+tmp_data[0]);
			setInputValues(tmp);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare achizitie "+elementData.no+"/"+elementData.aquisition_date_parsed});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteAquisition";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.no==="") {
				setMessageText("Eroare: Completati campul numar!");				
				document.getElementById("no").classList.add("required_input_error");
				return false;
			}
			if(inputValues.aquisition_date==="") {
				setMessageText("Eroare: Completati campul data!");				
				document.getElementById("aquisition_date").classList.add("required_input_error");
				return false;
			}
			if(inputValues.center_id===0) {
				setMessageText("Eroare: Alegeti centrul din lista!");				
				document.getElementById("center_id").classList.add("required_input_error");
				return false;
			}
			let url="saveAquisition";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			data.aquisition_date=format_date(data.aquisition_date,"yyyy-mm-dd");
			data.type=0;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="list_products") {
			let url="getAquisitionProducts";
			url+="?session_id="+props.session.sessId;
			oper="list_products";
			let data={
				aquisition_id: elementData.id,
			};
			currentAquisition=elementData;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="add_product") {
			setProductsList(dataValues.productsList);
			setInputValuesProducts(defaultInputValuesProducts);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Adaugare produs nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit_product") {
			elementData.filter_products=inputValuesProducts.filter_products;
			elementData.filter_product_type=inputValuesProducts.filter_product_type;
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===elementData.product_type_id)||(elementData.product_type_id==="")||(!elementData.product_type_id))));			
			setInputValuesProducts(elementData);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Editare produs "});
			setInputError(defaultInputError);
		}
		if(what==="delete_product") {
			let url="deleteAquisitionProduct";
			url+="?session_id="+props.session.sessId;
			oper="delete_product";
			let data={
				id: elementData.id,
				aquisition_id: currentAquisition.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_product") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValuesProducts.product_id) {
				setMessageText("Eroare: Alegeti un produs din lista!");				
				document.getElementById("product_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.product_mu_id) {
				setMessageText("Eroare: Alegeti o unitate de masura!");				
				document.getElementById("product_mu_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.quantity) {
				setMessageText("Eroare: Completati cantitatea!");				
				document.getElementById("quantity").classList.add("required_input_error");
				return false;
			}
			let url="saveAquisitionProduct";
			url+="?session_id="+props.session.sessId;
			oper="save_product";
			let data={...inputValuesProducts};
			data.aquisition_id=currentAquisition.id;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_quantities") {
			let url="saveQuantitiesAquisition";
			url+="?session_id="+props.session.sessId;
			oper="save_quantities";
			let tmp=[];
			Object.entries(tableQuantities).forEach(([id,quantity]) => {
				let c_quantity={};
				c_quantity.id=id;
				c_quantity.quantity=quantity;
				tmp.push(c_quantity);
			});
			let data={
				quantities: tmp,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="clone") {
			let tmp={...elementData};
			tmp.filter_centers=inputValues.filter_centers;
			tmp.filter_providers=inputValues.filter_providers;
			tmp.filter_years=inputValues.filter_years;
			let tmp_data=elementData.aquisition_date_parsed.split("-");
			tmp.aquisition_date=new Date(tmp_data[2]+"-"+tmp_data[1]+"-"+tmp_data[0]);
			tmp.no="";
			tmp.center_id=0;
			setInputValues(tmp);
			setDialogValues({...dialogValues,openClone: true,titleClone: "Clonare achizitie "+elementData.provider_name});
			setInputError(defaultInputError);
		}
		if(what==="save_clone") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValues.no) {
				setMessageText("Eroare: Completati numarul contractului!");				
				document.getElementById("no").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.aquisition_date) {
				setMessageText("Eroare: Selectati data achizitiei!");				
				document.getElementById("aquisition_date").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.center_id) {
				setMessageText("Eroare: Selectati centrul din lista!");				
				document.getElementById("center_id").classList.add("required_input_error");
				return false;
			}
			let url="cloneAquisition";
			url+="?session_id="+props.session.sessId;
			oper="save_clone";
			let data={...inputValues};
			data.aquisition_date=format_date(data.aquisition_date,"yyyy-mm-dd");
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")||(oper==="save_clone")) {
			setDialogValues(defaultDialogValues);
			if(oper==="get") {
				setDataValues({...dataValues,
											aquisitionsList:(result.aquisitionsList?result.aquisitionsList:[]),
											centersList:(result.centersList?result.centersList:[]),
											providersList:(result.providersList?result.providersList:[]),
				});				
			}else{
				setDataValues({...dataValues,aquisitionsList:(result.aquisitionsList?result.aquisitionsList:[])});
			}
			setAquisitionsList(result.aquisitionsList?result.aquisitionsList
																		.filter((aquisition)=>((aquisition.year===inputValues.filter_years))||(inputValues.filter_years===""))
																		.filter((aquisition)=>((aquisition.center_name.toLowerCase().indexOf(inputValues.filter_centers.toLowerCase())>-1))||(inputValues.filter_centers===""))
																		.filter((aquisition)=>((aquisition.provider_name.toLowerCase().indexOf(inputValues.filter_providers.toLowerCase())>-1))||(inputValues.filter_providers===""))										
			:[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if((oper==="list_products")||(oper==="save_product")||(oper==="delete_product")) {
			if(oper==="list_products") {
				setDataValues({...dataValues,
											aquisitionProductsList:(result.aquisitionProductsList?result.aquisitionProductsList:[]),
											productsList:(result.productsList?result.productsList:[]),
											MUsList:(result.MUsList?result.MUsList:[]),
											productsTypesList:(result.productsTypesList?result.productsTypesList:[])
				});							
			}else{
				setDataValues({...dataValues,aquisitionProductsList:(result.aquisitionProductsList?result.aquisitionProductsList:[])});							
			}
			setInputValuesProducts(defaultInputValuesProducts);
			setAquisitionProductsList(result.aquisitionProductsList?result.aquisitionProductsList
																					.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																					.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")))
			:[]);
			setDialogValues({...dialogValues,openListProducts: true,titleListProducts: "Lista de produse pentru achizitia ["+currentAquisition.provider_name+"]",
											openAddEditProduct: false,titleAddEditProduct: ""
			});
			if(result.aquisitionProductsList) {
				let tmp={};
				result.aquisitionProductsList.forEach(function(product) {
					tmp[product.id]=product.quantity;
				});
				setTableQuantities(tmp);
			}
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getAquisitions";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={2} lg={2} className="field padding-med">
						<label htmlFor="no">Numar*</label>
						<InputText name="no" id="no" style={{"width":"100%"}} value={inputValues.no} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} className="field padding-med">
						<label htmlFor="aquisition_date">Data*</label>
						<Calendar name="aquisition_date" id="aquisition_date" style={{"width":"100%"}} value={inputValues.aquisition_date} onChange={(evt) => handleChange(evt)} locale="ro" showIcon/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="center_id">Centru*</label>
						<Dropdown name="center_id" id="center_id" style={{"width":"100%"}} filter options={dataValues.centersList} optionLabel="name" optionValue="id" value={inputValues.center_id} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="provider_id">Furnizor*</label>
						<Dropdown name="provider_id" id="provider_id" style={{"width":"100%"}} filter options={dataValues.providersList} optionLabel="name" optionValue="id" value={inputValues.provider_id} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const listProductsDialog = () => {
		return(
			<Dialog header={dialogValues.titleListProducts} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListProducts:false})} className="responsive-dialog-big">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={4} lg={4} xl={5} className="field padding-med">
							<InputText name="filter_products" id="filter_products" style={{"width":"100%"}} value={inputValuesProducts.filter_products} placeholder="Cauta produs..." onChange={(evt) => handleChangeProducts(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3} className="field padding-med">
							<Dropdown name="filter_product_type" id="filter_product_type" style={{"width":"100%"}} filter options={dataValues.productsTypesList} placeholder="Filtrare categorie..." showClear optionLabel="name" optionValue="id" value={inputValuesProducts.filter_product_type} onChange={(evt) => handleChangeProducts(evt)}/>
						</Grid>						
						<Grid item xs={12} sm={12} md={5} lg={5} xl={4} className="field padding-med text-right">
							<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"9px"}} onClick={(evt) => {handleButton(evt,"save_quantities")}}/>
							<Button label="Adauga produs" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add_product")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							id="centers_requests_products"
							value={aquisitionProductsList}
							scrollable
							scrollHeight="60vh"
							style={{"minHeight":"63vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							rowGroupMode="rowspan"
							groupRowsBy="product_type"
							sortMode="single"
							sortField="product_type"
							sortOrder={1}
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="product_type" header="Tip produs" style={{"width":"25%","backgroundColor":"#FFFFFF"}} body={tableColTemplateProducts}></Column>
							<Column field="product_name" header="Produs" style={{"width":"48%"}}></Column>
							<Column field="unitary_price" header="Pret/U.M." style={{"width":"120px","textAlign":"center"}}></Column>
							<Column field="product_mu" header="U.M." style={{"width":"150px"}}></Column>
							<Column field="quantity" header="Cantitate" style={{"width":"60px","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="buttons" header="" style={{"width":"195px"}} body={tableColTemplateProducts}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const addEditProductDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditProduct} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_type_id">Categorie*</label>
						<Dropdown name="product_type_id" id="product_type_id" style={{"width":"100%"}} filter options={dataValues.productsTypesList} showClear optionLabel="name" optionValue="id" value={inputValuesProducts.product_type_id} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_id">Produs* ({productsList.length} produse gasite)</label>
						<Dropdown name="product_id" id="product_id" style={{"width":"100%"}} filter options={productsList} optionLabel="name" optionValue="id" value={inputValuesProducts.product_id} onChange={(evt) => handleChangeProducts(evt)} disabled={(inputValuesProducts.product_type_id?false:false)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="product_mu_id">Unitate de masura*</label>
						<Dropdown name="product_mu_id" id="product_mu_id" style={{"width":"100%"}} options={dataValues.MUsList} filter value={inputValuesProducts.product_mu_id} optionLabel="name" optionValue="id" onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="unitary_price">Pret unitar*</label>
						<InputText name="unitary_price" id="unitary_price" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.unitary_price} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="quantity">Cantitate*</label>
						<InputText name="quantity" id="quantity" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.quantity} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValuesProducts.observations} onChange={(evt) => handleChangeProducts(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_product")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const cloneDialog = () => {
		return(
			<Dialog header={dialogValues.titleClone} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openClone:false})} className="responsive-dialog-med-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="no">Numar*</label>
						<InputText name="no" id="no" style={{"width":"100%"}} value={inputValues.no} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="aquisition_date">Data achizitie*</label>
						<Calendar name="aquisition_date" id="aquisition_date" style={{"width":"100%"}} value={inputValues.aquisition_date} onChange={(evt) => handleChange(evt)} locale="ro" showIcon/>
					</Grid>
					<Grid item xs={12} sm={12} md={6} lg={6} className="field padding-med">
						<label htmlFor="center_id">Centru*</label>
						<Dropdown name="center_id" id="center_id" style={{"width":"100%"}} filter options={dataValues.centersList} optionLabel="name" optionValue="id" value={inputValues.center_id} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_clone")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openClone:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza achizitie" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Cloneaza" icon="pi pi-clone" tooltip="Duplicare" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"clone",row_data)}/>
					<Button label="Produse" icon="pi pi-list" tooltip="Lista de produse" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"list_products",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge achizitie" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
	}

	const tableColTemplateProducts = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza produs" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit_product",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge produs" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete_product",row_data)}/>
				</span>
			);
		}
		if(column.field==="product_type") {
			return(
				<div className="flex align-items-center gap-2">
					<span className="font-bold">{row_data.product_type}</span>
				</div>
			);
		}		
		if(column.field==="quantity") {
			return <InputText name="quantity_table" id={row_data.id} className="p-inputtext_table" value={tableQuantities[row_data.id]} pattern="[0-9.]*" onChange={(evt) => handleChangeTable(evt,row_data.id)} onKeyDown={(evt) => handleFocusTable(evt)} />;			
		}
	}

	const confirm = (evt,what,elementData) => {
		if((what==="delete")||(what==="delete_product")) {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={6} md={7} lg={7} xl={7} className="field padding-med">
							<InputText name="filter_centers" id="filter_centers" style={{"width":"40%","float":"left"}} value={inputValues.filter_centers} placeholder="Cauta centru..." onChange={(evt) => handleChange(evt)}/>							
							<InputText name="filter_providers" id="filter_providers" style={{"width":"40%","float":"left","marginLeft":"6px"}} value={inputValues.filter_providers} placeholder="Cauta furnizor..." onChange={(evt) => handleChange(evt)}/>							
							<Dropdown name="filter_years" id="filter_years" style={{"width":"16%","marginLeft":"6px"}} options={yearsList} value={inputValues.filter_years} onChange={(evt) => handleChange(evt)}/>	
						</Grid>						
						<Grid item xs={12} sm={3} md={3} lg={3} xl={3} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{aquisitionsList.length} {(((aquisitionsList.length>1)||(aquisitionsList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={3} md={2} lg={2} xl={2} className="field padding-med text-right">
							<Button label="Adauga achizitie" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={aquisitionsList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="no" header="Numar" style={{"flexGrow":"0","flexBasis":"60px"}} sortable></Column>
								<Column field="aquisition_date_parsed" header="Data" style={{"flexGrow":"0","flexBasis":"90px"}} sortable></Column>
								<Column field="center_name" header="Centru" style={{"flexGrow":"1","flexBasis":"255px"}} sortable></Column>
								<Column field="provider_name" header="Furnizor" style={{"flexGrow":"1","flexBasis":"255px"}} sortable></Column>
								<Column field="observations" header="Observatii" style={{"flexGrow":"1","flexBasis":"255px"}}></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"387px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openListProducts && listProductsDialog()}
				{dialogValues.openAddEditProduct && addEditProductDialog()}
				{dialogValues.openClone && cloneDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default Aquisitions;


